import { html, render } from "lit-html";
import { determineTranslation } from "../../components-shared/utils/language.js";
import { ShippingDialog } from "./shipping-dialog.js";

export class ShippingDetails extends HTMLElement {
    
    constructor() {
        super();
        this.labels = determineTranslation(this.translations);
    }

    /* #region Translations */
    private translations = {
        en: {
            title: "Calculate shipping cost"
        },
        no: {
            title: "Beregn fraktkostnad"
        }
    };

    private labels: { [key: string]: any };
    /* #endregion */

    /* #region Markup */
    private template = () => html`
        <button class="btn btn-link btn-calculate-shipping-cost" type="button" @click=${this.onClick.bind(this)}><span>${this.labels.title}</span></button>
    `;
    /* #endregion */

    private async onClick(e: MouseEvent) {
        e.preventDefault();

        await this.dialog.showModal();
    }

    private dialog: ShippingDialog;

    private render() {
        render(this.template(), this);
    }
    /* #endregion */

    /* connectedCallback */
    async connectedCallback() {
        this.dialog = new ShippingDialog();

        document.body.appendChild(this.dialog);

        this.render();
    }

    public set shippingProducts(products) {
        this.dialog.requestedProducts = products;
    }
}

customElements.define("shipping-details", ShippingDetails);